module.exports = __webpack_public_path__ + "static/media/bano-cubro.a81d4a66.png";